// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.innovation {
  bottom: 50%;
  right: -10%;
}

@media (max-width: 500px) {
  h1 {
    font-size: 2em;
  }
  h3 {
    font-size: 1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/about/team/team.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;AACF;;AAGA;EACE;IACE,cAAA;EAAF;EAEA;IACE,cAAA;EAAF;AACF","sourcesContent":[".innovation {\r\n  bottom: 50%;\r\n  right: -10%;\r\n}\r\n\r\n\r\n@media (max-width: 500px) {\r\n  h1 {\r\n    font-size: 2em;\r\n  }\r\n  h3 {\r\n    font-size: 1em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
